// Need to use the React-specific entry point to allow generating React hooks
import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from './queries'
import { ModelsResponse } from '../../types/api-types'
import { RawConfig } from '../store/slice/configSlice'

// API used for the Model ressource
export const apiModel = createApi({
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getModels: builder.query<ModelsResponse, RawConfig | null>({
            providesTags: ['Model'],
            query: (input) => {
                return {
                    url: '/models',
                    params: input || undefined,
                }
            },
        }),
    }),
    reducerPath: 'apiModel',
    tagTypes: ['Model'],
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetModelsQuery } = apiModel

// Invalidate Action to refresh the Model object
export const invalidateGetModelsAction = {
    payload: ['Model'],
    type: 'apiModel/invalidateTags',
}
